// Third-party web analytics (LAUNCH_CHECKLIST B35, owner decision of 2026-10-29; DESIGN 5.10): Cloudflare Web Analytics
// counts every visit to capywars.com, landing section included (cookieless and without identifiers, so it needs no consent
// and runs in child mode too), and Google Analytics runs only for adults who allow it (app/googleAnalytics.ts). Only the
// production host reports: staging, localhost and the tests load neither.

export const ANALYTICS_HOST = 'capywars.com';
/** the public site token of the capywars.com site in Cloudflare Web Analytics (WEB FLAG account) */
export const CF_BEACON_TOKEN = '393afa5a39ad4ec5b2bcb3b9cc390d60';
export const CF_BEACON_SRC = 'https://static.cloudflareinsights.com/beacon.min.js';
/** the measurement id of the "CapyWars web" stream of the GA4 property CapyWars */
export const GA_MEASUREMENT_ID = 'G-4VM8EVBBCT';

export function reportsAnalytics(hostname: string): boolean {
  return hostname === ANALYTICS_HOST;
}

/**
 * Adds Cloudflare's beacon once, on the production host. Not on the guardian pages, whose path carries the emailed
 * token (DESIGN 5.1a).
 */
export function loadCloudflareBeacon(doc: Document, loc: { hostname: string; pathname: string }): void {
  if (!reportsAnalytics(loc.hostname) || loc.pathname.startsWith('/guardian/')) return;
  if (doc.querySelector('script[data-cf-beacon]') !== null) return;
  const script = doc.createElement('script');
  script.defer = true;
  script.src = CF_BEACON_SRC;
  script.setAttribute('data-cf-beacon', JSON.stringify({ token: CF_BEACON_TOKEN, spa: true }));
  doc.head.appendChild(script);
}
